import { Check } from "lucide-react";

// Tap-to-select pill buttons. `multi` allows several choices (value is an array).
export const Chips = ({ options, value, onChange, multi = false, testid, cols = "grid-cols-2" }) => {
  const on = (o) => (multi ? value.includes(o) : value === o);
  const toggle = (o) => {
    if (!multi) return onChange(value === o ? "" : o);
    onChange(on(o) ? value.filter((v) => v !== o) : [...value, o]);
  };
  return (
    <div className={`mt-3 grid gap-2 ${cols}`} role={multi ? "group" : "radiogroup"}>
      {options.map((o, i) => (
        <button type="button" key={o} onClick={() => toggle(o)} aria-pressed={on(o)} data-testid={`${testid}-${i}`}
          className={`flex min-h-[48px] items-center gap-2 border px-3 py-2 text-left text-sm font-light transition-colors ${on(o) ? "border-neutral-950 bg-neutral-950 text-white" : "border-neutral-300 text-neutral-800 hover:border-neutral-950"}`}>
          {multi && <span className={`flex h-4 w-4 shrink-0 items-center justify-center border ${on(o) ? "border-white" : "border-neutral-400"}`}>{on(o) && <Check size={12} strokeWidth={2} />}</span>}
          {o}
        </button>
      ))}
    </div>
  );
};
